import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getServiceCatalog, createReferral } from '../api/api';
import { uiAlert } from '../components/Modal';
import { uiToastSuccess, uiToastError } from '../components/Toast';

function NuevaReferida() {
  const navigate = useNavigate();
  const [catalog, setCatalog] = useState([]);
  const [providerId, setProviderId] = useState('');
  const [formData, setFormData] = useState({
    service_id: '',
    prospect_name: '',
    prospect_phone: '',
    notes: '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getServiceCatalog().then(res => setCatalog(res.data)).catch(() => {});
  }, []);

  // Lista única de miembros, ordenada por nombre de negocio. Se descartan entradas sin
  // nombre de negocio (perfil incompleto) para no tronar el ordenamiento ni mostrar un
  // miembro sin negocio en el selector.
  const providers = Array.from(
    new Map(catalog.map(c => [c.provider_id, { provider_id: c.provider_id, business_name: c.business_name }])).values()
  )
    .filter(p => p.business_name)
    .sort((a, b) => a.business_name.localeCompare(b.business_name));

  // Servicios del miembro seleccionado
  const servicesForProvider = catalog.filter(c => String(c.provider_id) === String(providerId));

  const handleProviderChange = (e) => {
    setProviderId(e.target.value);
    setFormData({ ...formData, service_id: '' });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const selected = catalog.find(c => String(c.service_id) === String(formData.service_id));
    if (!selected) {
      await uiAlert('Selecciona un servicio válido');
      return;
    }
    setLoading(true);
    try {
      await createReferral({
        provider_id: selected.provider_id,
        service_id: selected.service_id,
        prospect_name: formData.prospect_name,
        prospect_phone: formData.prospect_phone,
        notes: formData.notes.trim() || undefined,
      });
      uiToastSuccess('Referencia creada.');
      navigate('/dashboard');
    } catch (err) {
      uiToastError('Error al crear referencia: ' + (err.response?.data?.error || err.message));
    }
    setLoading(false);
  };

  return (
    <div className="page-narrow">
      <h1 className="page-title">Nueva Referencia</h1>
      <p className="page-subtitle">Recomienda a un miembro del hub con un prospecto tuyo.</p>

      <div className="card">
        <form onSubmit={handleSubmit}>
          <div className="two-col-grid">
            <div className="form-group">
              <label className="form-label">Miembro</label>
              <select value={providerId} onChange={handleProviderChange} required className="form-select">
                <option value="">Selecciona un miembro...</option>
                {providers.map(p => (
                  <option key={p.provider_id} value={p.provider_id}>{p.business_name}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Servicio</label>
              <select
                name="service_id"
                value={formData.service_id}
                onChange={handleChange}
                required
                disabled={!providerId}
                className="form-select"
              >
                <option value="">{providerId ? 'Selecciona un servicio...' : 'Primero elige un miembro'}</option>
                {servicesForProvider.map(s => (
                  <option key={s.service_id} value={s.service_id}>{s.service_name}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="two-col-grid">
            <div className="form-group">
              <label className="form-label">Nombre del prospecto</label>
              <input type="text" name="prospect_name" value={formData.prospect_name} onChange={handleChange} required className="form-input" />
            </div>
            <div className="form-group">
              <label className="form-label">Teléfono del prospecto</label>
              <input type="text" name="prospect_phone" value={formData.prospect_phone} onChange={handleChange} className="form-input" />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Comentarios (opcional)</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              className="form-input"
              rows={3}
              maxLength={500}
              placeholder="Ej. ya le platiqué de tu servicio, solo falta que le llames / lo conocí en el evento de septiembre..."
            />
          </div>
          <button type="submit" disabled={loading} className="btn btn-primary btn-block">
            {loading ? 'Guardando...' : 'Guardar referencia'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default NuevaReferida;
